import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import {
	getDateString,
	getDownloadLink,
	splitQuery,
} from '../../Shares/CommonUtil';
import { cdnUrlConfig } from '../../Utils/atoms';

/**
 * 게임의왕좌 2023년 프로모션 페이지
 */
const GameKing2023Promotion = () => {
	const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}/BigglzEvent`;

	const isApp = window.location.pathname.includes('app'); //URL에 "app"이 포함되면 true
	const { search } = useLocation();
	const querys = splitQuery(search);

	const date = querys['date'] ? querys['date'] : ''; // yyyyMM
	const { month, firstDayString, lastDayString, resultDateString } =
		getDateString(date);

	function onGameKingTitleImageError(event) {
		event.target.src = `${IMG_URL}/images/gameking/tit_game_default.png`;
	}

	return (
		<div id='wrap'>
			<div className='container'>
				<div className='content'>
					<div className='game-king promotion'>
						<h1>
							<img
								src={`${IMG_URL}/images/gameking/tit_game_${date}.png`}
								onError={(event) => onGameKingTitleImageError(event)}
								alt='게임의 왕좌 타이틀'
							/>
						</h1>
						<p className='txt'>미니게임 {month}월 이벤트</p>
						{/* 경품안내 */}
						<div className='event-info product-area'>
							<div className='tit-area'>
								<h2>
									<span>
										<span>경품안내</span>
									</span>
								</h2>
							</div>
							<p className='txt'>
								미니게임에서 최고의 자리에 도전해보세요.
								<br />
								왕좌를 차지하신 분들께는 <strong>소정의 상품</strong>을
								제공합니다.
							</p>
							<ol className='product-list'>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/gameking/img_product1.png`}
											alt='img_product1'
										/>
										<figcaption>
											도미노피자 뉴욕 오리진 M (오리지널) + 콜라 1.25L + BBQ황금
											올리브 치킨 + 콜라 1.25L
										</figcaption>
									</figure>
									<div className='info'>
										<div className='lb top1'>1등</div>
										<div className='tit-product'>
											도미노피자 뉴욕 오리진 M (오리지널) + 콜라 1.25L
											<br /> + BBQ황금 올리브 치킨 + 콜라 1.25L
										</div>
									</div>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/gameking/img_product2.png`}
											alt='img_product2'
										/>
										<figcaption>교촌치킨 반반콤보 웨지 감자 세트</figcaption>
									</figure>
									<div className='info'>
										<div className='lb top2'>2등</div>
										<div className='tit-product'>
											교촌치킨 반반콤보 웨지 감자 세트
										</div>
									</div>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/gameking/img_product3.png`}
											alt='img_product3'
										/>
										<figcaption>베스킨라빈스 파인트</figcaption>
									</figure>
									<div className='info'>
										<div className='lb top3'>3등</div>
										<div className='tit-product'>베스킨라빈스 파인트</div>
									</div>
								</li>
							</ol>
						</div>
						{/* 이벤트 상세 안내 */}
						<div className='event-info detail'>
							<h2>이벤트 상세 안내</h2>
							<ul>
								<li>
									<div className='tit-info'>
										<span>참여기간</span>
									</div>
									<div className='txt'>
										{firstDayString} ~ {lastDayString}
									</div>
								</li>
								<li>
									<div className='tit-info'>
										<span>발표일</span>
									</div>
									<div className='txt'>{resultDateString}</div>
								</li>
								<li>
									<div className='tit-info'>
										<span>지급대상</span>
									</div>
									<div className='txt'>
										미니게임 9종의 점수 총 합이 가장 높은 3인
									</div>
								</li>
							</ul>
						</div>
						{/* 함께 즐겨요 */}
						<div className='event-info ranking'>
							<h2>친구와 함께 게임을 즐겨요~!</h2>
							<ol>
								<li>
									<div className='rank'>1</div>
									<div className='info'>
										<figure>
											<img
												src={`${IMG_URL}/images/gameking/photo1.png`}
												alt='photo1'
											/>
											<figcaption>
												<span>탄이</span>
											</figcaption>
										</figure>
										<div className='score'>230,000</div>
									</div>
								</li>
								<li>
									<div className='rank'>2</div>
									<div className='info'>
										<figure>
											<img
												src={`${IMG_URL}/images/gameking/photo2.png`}
												alt='photo2'
											/>
											<figcaption>
												<span>레오</span>
											</figcaption>
										</figure>
										<div className='score'>183,000</div>
									</div>
								</li>
								<li>
									<div className='rank'>3</div>
									<div className='info'>
										<figure>
											<img
												src={`${IMG_URL}/images/gameking/photo3.png`}
												alt='photo3'
											/>
											<figcaption>
												<span>망고</span>
											</figcaption>
										</figure>
										<div className='score'>158,000</div>
									</div>
								</li>
							</ol>
						</div>
						{/* 참여방법 */}
						<div className='event-info how-to'>
							<div className='tit-area'>
								<h2>
									<span>
										<span>참여방법</span>
									</span>
								</h2>
							</div>
							<ol>
								<li>
									<div className='num'>1</div>
									<div className='txt'>비글즈 앱을 다운로드 받으세요</div>
									<div className='tip'>
										<figure>
											<img
												src={`${IMG_URL}/images/gameking/img_capture01.png`}
												alt='img_capture01'
											/>
											<figcaption>비글즈 앱</figcaption>
										</figure>
									</div>
								</li>
								<li>
									<div className='num'>2</div>
									<div className='txt'>9가지 미니게임 플레이 하기</div>
									<div className='tip'>
										<figure>
											<img
												src={`${IMG_URL}/images/gameking/img_game1.png`}
												alt='img_game1'
											/>
											<figcaption>야생동물이 나타났다</figcaption>
										</figure>
										<figure>
											<img
												src={`${IMG_URL}/images/gameking/img_game2.png`}
												alt='img_game2'
											/>
											<figcaption>모닥불 앞에서 춤을</figcaption>
										</figure>
										<figure>
											<img
												src={`${IMG_URL}/images/gameking/img_game3.png`}
												alt='img_game3'
											/>
											<figcaption>꽃들이 모여모여</figcaption>
										</figure>
										<figure>
											<img
												src={`${IMG_URL}/images/gameking/img_game4.png`}
												alt='img_game4'
											/>
											<figcaption>명화를 감상하자</figcaption>
										</figure>
										<figure>
											<img
												src={`${IMG_URL}/images/gameking/img_game5.png`}
												alt='img_game5'
											/>
											<figcaption>무도회장 밤의 열기</figcaption>
										</figure>
										<figure>
											<img
												src={`${IMG_URL}/images/gameking/img_game6.png`}
												alt='img_game6'
											/>
											<figcaption>샴페인 대소동</figcaption>
										</figure>
										<figure>
											<img
												src={`${IMG_URL}/images/gameking/img_game7.png`}
												alt='img_game7'
											/>
											<figcaption>선물을 향해 쏴라</figcaption>
										</figure>
										<figure>
											<img
												src={`${IMG_URL}/images/gameking/img_game8.png`}
												alt='img_game8'
											/>
											<figcaption>락 앤 롤 아웃</figcaption>
										</figure>
										<figure>
											<img
												src={`${IMG_URL}/images/gameking/img_game9.png`}
												alt='img_game9'
											/>
											<figcaption>몸도 마음도 락스타</figcaption>
										</figure>
									</div>
								</li>
								<li>
									<div className='num'>3</div>
									<div className='txt'>
										9가지 미니게임의 총 점이 가장 높은사람이 우승!
									</div>
									<div className='tip'>
										<span>
											1800<i className='plus'>+</i>15832
											<i className='plus'>+</i>10342<i className='plus'>+</i>
											10009
											<span>
												...<i className='plus'>+</i>2100
												<i className='plus'>+</i>1230
											</span>
										</span>
										<span>
											<i className='result'>=</i>103942
										</span>
									</div>
								</li>
							</ol>
						</div>
						{/* 확인해주세요 */}
						<div className='cautionary'>
							<dl>
								<dt>확인해주세요!</dt>
								<dd>
									왕좌는 오직 1명당 1개만 차지할 수 있습니다.
									&#40;중복당첨불가&#41;
								</dd>
								<dd>
									당첨자 발표 후 7일 이내로 문의 접수를 해주시지 않을 경우
									당첨자에서 제외될 수 있습니다.
								</dd>
								<dd>
									이벤트는 기프티콘 형태로 지급이 되기 때문에 정확한 전화번호를
									입력해 주셔야 경품 발송이 가능합니다.
								</dd>
								<dd>이벤트 상품은 교환 및 환불이 불가합니다.</dd>
								<dd>
									잘못된 배송 정보로 인해 상품을 받지 못할 경우에는 재배송이
									불가합니다.
								</dd>
								<dd>
									해당 경품은 만료 기간이 존재하는 상품으로 꼭 기간 내 사용을
									부탁 드립니다.
								</dd>
								<dd>해당 이벤트는 앱스토어와 무관합니다.</dd>
							</dl>
						</div>
						{isApp ? (
							<>
								{/* 다운로드 버튼 */}
								<a
									href={getDownloadLink()}
									target='_blank'
									rel='noopener noreferrer'
									className='btn-download'
								>
									<i></i>앱 다운로드 하러가기
								</a>
							</>
						) : (
							<div className='floating'>
								<img
									src={`${IMG_URL}/images/gameking/logo.png`}
									alt='logo.png'
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default GameKing2023Promotion;
